import { observer } from 'mobx-react';
import React from 'react';
import { useParams } from 'react-router';
import { PageHeader } from '@components/page-header';
import { Spinner } from '@components/spinner';
import { Alert, AlertDescription } from '@components/ui/alert';
import { ProductInfoSection } from './product-info-section';
import { useProductDetailsStore } from './store';

export const ProductDetails = observer(() => {
    const { vendorId, productId } = useParams();
    const { product, handleUpdateProductState, updateProductState } =
        useProductDetailsStore();

    React.useEffect(() => {
        if (vendorId && productId) {
            product.request([Number(vendorId), Number(productId)]);
        }
    }, [vendorId, productId]);

    const productData = product.result;

    if (product.loading) {
        return (
            <div className="flex min-h-[400px] items-center justify-center">
                <Spinner />
            </div>
        );
    }

    if (product.error) {
        return (
            <Alert variant="destructive">
                <AlertDescription>
                    Error loading product details: {product.error.message}
                </AlertDescription>
            </Alert>
        );
    }

    if (!productData) {
        return null;
    }

    const reload = () => product.request([Number(vendorId), Number(productId)]);

    return (
        <>
            <PageHeader title={productData.symbol} />
            <ProductInfoSection
                product={productData}
                vendorId={Number(vendorId)}
                productId={Number(productId)}
                onToggleState={(state) =>
                    handleUpdateProductState(
                        Number(vendorId),
                        Number(productId),
                        state
                    )
                }
                loading={updateProductState.loading}
                onImageUpdate={reload}
                onPriceUpdate={reload}
            />
        </>
    );
});
